// @ts-nocheck
import { USER_DETAILS_ERROR, USER_DETAILS_LOADING, USER_DETAILS_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const user_details = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: USER_DETAILS_LOADING,
                data: true
            })
            Authservices.user_details(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: USER_DETAILS_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: USER_DETAILS_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}